import styled from "styled-components";
import { device } from "../../../globalStyles/breakpoints";

export const TAAOptionsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const TAAOptions = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: no-wrap;

  ${device.desktop} {
    width: 60%;
  }
`;

export const TAAChartLegend = styled.ul`
  display: flex;
  align-items: center;
  margin: 0 0 0 3px;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  justify-content: space-evenly;
`;

export const TAAChartLendItem = styled.li`
  display: flex;
  align-items: center;
`;

export const TAALegendItemDot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 5px;
`;
